import { Link } from "react-router-dom";
import { LOGO } from "../../lib/brand";

export const Logo = ({ testId = "brand-home-link", compact = false }) => (
  <Link to="/" className={compact ? "brand-logo compact" : "brand-logo"} data-testid={testId}>
    <img src={LOGO} alt="ML FAB Enterprises Pvt Ltd logo" />
  </Link>
);
